module.exports = __webpack_public_path__ + "static/img/case3.9381648.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/case3.jpg
// module id = WqqH
// module chunks = 1